import React from 'react'
import Router from 'next/router'
import { Select } from '@ticketswap/solar'
import { items } from './menu-items'
import visit from '~/utils/visit'

const NativeMenuDropdown = ({ t }) => {
  const options = [...items.primary, ...items.legal].map(item => ({
    ...item,
    value: item.title,
    name: t(item.title),
  }))
  const path = Router.router ? Router.router.asPath : ''

  return (
    <Select
      onChange={({ as, href, url }) => {
        if (url) {
          return (window.location = url)
        }

        return visit({ href, as })
      }}
      id="menu-dropdown"
      label={t('footer.primary.title')}
      hideLabel
      items={options}
      initialSelectedItem={options.find(({ as }) => as === path) || options[0]}
    />
  )
}

export default NativeMenuDropdown
